//@flow
import type {AdvancedLocationAdmin1} from '../../../../entities/logistic/delivery-method/advanced';
import type {AdminAddress} from '../../../../entities/logistic';

export function filterAdmin1(
  adminList: AdminAddress[],
  location: AdvancedLocationAdmin1
): AdminAddress[] {
  return adminList.filter(admin => location[admin.adminId] !== undefined);
}

export function filterAdmin2(
  adminList: AdminAddress[],
  selectedAdmin1: string,
  location: AdvancedLocationAdmin1 | boolean
): AdminAddress[] {
  if (typeof location === 'boolean') return adminList;
  const admin1Location = location[selectedAdmin1];
  if (typeof admin1Location === 'boolean') return adminList;
  return adminList.filter(
    admin => admin1Location && admin1Location[admin.adminId] !== undefined
  );
}

export function filterAdmin3(
  adminList: AdminAddress[],
  selectedAdmin1: string,
  selectedAdmin2: string,
  location: AdvancedLocationAdmin1 | boolean
): AdminAddress[] {
  if (typeof location === 'boolean') return adminList;
  const admin1Location = location[selectedAdmin1];
  if (typeof admin1Location !== 'object') return adminList;
  const admin2Location = admin1Location[selectedAdmin2];
  if (typeof admin2Location === 'boolean') return adminList;
  return adminList.filter(
    admin => admin2Location && admin2Location[admin.adminId] !== undefined
  );
}
